import { render, staticRenderFns } from "./OnboardingAthleteStats.vue?vue&type=template&id=2862aebe&"
import script from "./OnboardingAthleteStats.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAthleteStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports